import { css, keyframes } from '@emotion/react';

interface SpinnerProps {
  size?: 'sm' | 'md';
  color?: string;
  'aria-hidden'?: boolean;
}

const sizes = { sm: '14px', md: '24px' } as const;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export function Spinner({ size = 'md', color = 'currentColor', ...rest }: SpinnerProps) {
  const px = sizes[size];
  const isHidden = rest['aria-hidden'];

  return (
    <span
      role={isHidden ? undefined : 'status'}
      aria-label={isHidden ? undefined : 'Loading'}
      aria-hidden={isHidden || undefined}
      data-testid="spinner"
      css={css`
        display: inline-block;
        width: ${px};
        height: ${px};
        border: 2px solid transparent;
        border-top-color: ${color};
        border-left-color: ${color};
        border-radius: 50%;
        animation: ${spin} 0.6s linear infinite;
      `}
    />
  );
}
